import React, { useState } from "react";
import SecctionTitle from "../../components/shared/secction_title";
import { LocaleContext } from "../layout";
import PortfolioLogoGrid from "../portfolio/portfolio-logo-grid";
import Carousel from "react-simply-carousel";
import { Link } from "gatsby";

const CarruselLol = ({ data }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const lang = React.useContext(LocaleContext);
  const preUrl = lang.locale !== "en-gb" ? "/portfolio" : "/en/portfolio";

  return (
    <div>
      <Carousel
        updateOnItemClick
        containerProps={{
          style: {
            width: "100%",
            justifyContent: "space-between",
          },
        }}
        activeSlideIndex={activeSlide}
        onRequestChange={setActiveSlide}
        forwardBtnProps={{
          children: ">",
          style: {
            width: "40px",
            height: " 40px",
            miWidth: "20px",
            alignSelf: "center",
            border: "none",
            lineHeight: "22px",
            cursor: "pointer",
          },
        }}
        backwardBtnProps={{
          children: "<",
          style: {
            width: "40px",
            height: " 40px",
            miWidth: "20px",
            alignSelf: "center",
            border: "none",
            lineHeight: "22px",
            cursor: "pointer",
          },
        }}
        itemsToShow={3}
        speed={400}
      >
        {data.map((item, index) => (
          <div
            style={{
              // background: "red",
              width: 300,
              textAlign: "center",
              boxSizing: "border-box",
            }}
            className="portfolio_logo_carrusel"
            key={index}
          >
            <div>
              <Link to={preUrl + "#" + item.node.uid}>
                <div className="logobox">
                  <img
                    className="color"
                    src={item.node.data.logo_grid_color.url}
                    alt="logo"
                  />
                </div>
              </Link>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

const PortfolioGrid = ({ data }) => {
  const lang = React.useContext(LocaleContext);
  const i18n = lang.i18n[lang.locale];
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <div className="our_aventures content carrusel_block">
      <SecctionTitle text={"Portfolio"}></SecctionTitle>
      <div className="layout">
        <PortfolioLogoGrid data={data} home={true}></PortfolioLogoGrid>
      </div>
      {/* <div className="layout">
        <CarruselLol data={data}></CarruselLol>
      </div> */}
    </div>
  );
};
export default PortfolioGrid;
